import React, { useState, useEffect, useRef, useCallback } from 'react';
import { withTranslation } from '../../../ChildrenContext.js';
import PropTypes from 'prop-types';
import CustomModal from '../../../Modal';
import FormGroup from '../../../FormGroup';
import Button from '../../../Button';
import CustomNotify from '../../../Notify';

const PostbackTest = ({ 
    id, 
    loadingSave, 
    saveSuccess, 
    edit, 
    modalIsVisible, 
    loading, 
    data, 
    visibleModal, 
    hiddenModal, 
    clear, 
    testing, 
    t 
}) => {
    const [state, setState] = useState({
        loadingSave: loadingSave,
        saveSuccess: saveSuccess,
        modalIsVisible: modalIsVisible,
        loading: loading,
        data: data || {}
    });

    const isTestingRef = useRef(modalIsVisible || false);

    const staticNames = t?.postbackPage?.creatingEditing || {};

    const onShowModal = useCallback(() => {
        isTestingRef.current = true;
        if (typeof visibleModal === 'function') {
            visibleModal();
        }
        setState(prevState => ({
            ...prevState,
            modalIsVisible: true
        }));
    }, [visibleModal]);

    const onCloseModal = useCallback(() => {
        isTestingRef.current = false;

        if (typeof hiddenModal === 'function') {
            hiddenModal();
        }

        if (typeof clear === 'function') {
            clear();
        }

        setState(prevState => ({
            ...prevState,
            modalIsVisible: false
        }));
    }, [hiddenModal, clear]);

    const onTesting = useCallback(() => {
        if (!id) {
            CustomNotify(staticNames.test?.saveBefore || 'Save postback before testing', 'error');
            return;
        }
        testing(id);
    }, [testing, id, staticNames.test]);

    const prevLoadingSaveRef = useRef(loadingSave);
    const prevSaveSuccessRef = useRef(saveSuccess);

    useEffect(() => {
        const wasLoading = prevLoadingSaveRef.current;
        const wasSaveSuccess = prevSaveSuccessRef.current;
        const isSuccessSavePostback = wasLoading && saveSuccess;
        const isFailSavePostback = wasLoading && !saveSuccess;
        const isChangeSaveLoading = !wasSaveSuccess && saveSuccess;

        setState(prevState => {
            let modalIsVisible = prevState.modalIsVisible;

            if (isFailSavePostback && isTestingRef.current) {
                isTestingRef.current = false;
                hiddenModal();
                modalIsVisible = false;
            }

            if (isSuccessSavePostback && !edit && isTestingRef.current) {
                modalIsVisible = true;
            }

            if (edit) {
                modalIsVisible = (isTestingRef.current && isChangeSaveLoading) || (prevState.modalIsVisible && isTestingRef.current);
            }

            return {
                ...prevState,
                loadingSave,
                saveSuccess,
                loading,
                data: data || {},
                modalIsVisible
            };
        });

        prevLoadingSaveRef.current = loadingSave;
        prevSaveSuccessRef.current = saveSuccess;
    }, [loadingSave, saveSuccess, loading, data, hiddenModal]);


    return (
        <div className="postback__test">
            <div className="postback__test-toolbar">
                <Button
                    type={'submit'}
                    loading={state.loadingSave}
                    extraClass={{'btn-w-m roundButton bold': true}}
                    text={staticNames.save}
                />
                <Button
                    type={'button'}
                    loading={state.loadingSave}
                    extraClass={{'btn-w-m roundButton bold': true}}
                    text={staticNames.test?.btn}
                    onClick={onShowModal}
                />
            </div>
            <CustomModal
                visible={state.modalIsVisible}
                onClose={onCloseModal}
                title={staticNames.test?.modalTitle}
                confirmName={staticNames.test?.btn}
                onConfirm={onTesting}
                loading={state.loading}
            >
                <p>{staticNames.test?.modalText}</p>
                {Object.keys(state.data).length
                    ? (
                        <React.Fragment>
                            <div className="form-horizontal postback__test-body">
                                <FormGroup
                                    label={staticNames.test?.form?.status}
                                >
                                    {state.data.success
                                        ?
                                        <span className="label label-success">{staticNames.test?.form?.success}</span>
                                        : <span className="label label-danger">{staticNames.test?.form?.error}</span>
                                    }
                                </FormGroup>
                                <FormGroup
                                    label={staticNames.test?.form?.request}
                                >
                                    <div className="form-control">{state.data.request}</div>
                                </FormGroup>
                                <FormGroup
                                    label={staticNames.test?.form?.response}
                                >
                                    <div className="form-control">{state.data.response}</div>
                                </FormGroup>
                            </div>
                        </React.Fragment>
                    )
                    : null
                }

            </CustomModal>
        </div>
    );
};

PostbackTest.propTypes = {
    modalIsVisible: PropTypes.bool,
    edit: PropTypes.bool,
    visibleModal: PropTypes.func,
    hiddenModal: PropTypes.func,
    clear: PropTypes.func,
    testing: PropTypes.func
};

PostbackTest.defaultProps = {
    modalIsVisible: false,
    edit: false
};

export default withTranslation(PostbackTest);
